import { UserProfile, UserRole } from "@/types";
import { useProfileFetching } from "./useProfileFetching";
import { useAuthBasicActions } from "./actions/authBasicActions";
import { useNotificationActions } from "./actions/notificationActions";
import { useRoleActions } from "./actions/roleActions";

export const useAuthActions = (
  setUser: React.Dispatch<React.SetStateAction<UserProfile | null>>,
  setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>,
  setNotifications: React.Dispatch<React.SetStateAction<unknown[]>>,
  setIsLoggingOut: React.Dispatch<React.SetStateAction<boolean>>
) => {
  // Create basic auth actions with logout function and isLoggingOut setter
  const basicActions = useAuthBasicActions(
    setUser, 
    setIsAuthenticated, 
    setIsLoggingOut
  );

  // Create profile fetching utilities with logout function
  const profileUtils = useProfileFetching(basicActions.logout);

  // Create other action modules
  const notificationActions = useNotificationActions(setNotifications);
  const roleActions = useRoleActions(setUser);

  // Return all actions and utilities
  return {
    ...basicActions,
    ...notificationActions,
    switchRole: (role: UserRole) => roleActions.switchRole(role, basicActions.getCurrentUser()),
    impersonateUser: (userId: string) => roleActions.impersonateUser(userId, basicActions.getCurrentUser()),
    fetchUserProfile: profileUtils.fetchUserProfile,
    fetchNotifications: profileUtils.fetchNotifications
  };
};
